<template>
  <div id="page" class="bg-light">
    <h2 class="page-title"><!---->
      {{ $t('bandeauConfiguration.default') }}
    </h2>

    <b-card no-body class="card-show">
      <b-tabs v-if="dataLoaded">
        <div class="tab p-2v">
          <div v-for="row in rows" :key="row.id"  class="row border-top">
            <row v-for="item in row" :item="item" :width="getWidth(row)" ></row>
          </div>
        </div>
      </b-tabs>
    </b-card>
    <button-group :class="'mt-2'" :buttons="buttons" :positioning-clues="positioningClues">

    </button-group>
  </div>
</template>

<script>
import bTabs from 'bootstrap-vue/es/components/tabs/tabs'
import bCard from 'bootstrap-vue/es/components/card/card'
import CommonApi from '@/api/commonApi'
import Row from '@/components/backoffice/show/tabs/row.vue'
import textComponent from '@/components/backoffice/type/text.vue'
import fontAwesome from '@/components/global/icon/fontAwesome.vue'
import bButton from 'bootstrap-vue/es/components/button/button'
import buttonGroup from '@/components/backoffice/button/group.vue'
import Moment from 'moment/moment'

export default {
  components: {
    buttonGroup,
    bButton,
    fontAwesome,
    Row,
    textComponent,
    bCard,
    bTabs
  },

  data () {
    return {
      dataLoaded: false,
      rows: [

      ],
      buttons: [
        {
          'id': 'modify',
          'text': 'Modifier',
          'route': '/admin/bandeau/edit',
          'bootstrapClass': 'btn-secondary bg-primary'
        }
      ],
      positioningClues: { position: 'right', overall: {} }
    }
  },

  created () {
    this.errorTitle = this.$t('error.error')
    this.errorMsg = this.$t('error.error')
    let commonApi = new CommonApi()
    commonApi.getBandeauConfigurations()
      .then(bandeauDatas => {
        let currentIndex = 0
        for (const [key, value] of Object.entries(bandeauDatas.data.data)) {
          if (currentIndex % 2 === 0) {
            this.rows.push([])
          }
          this.rows[this.rows.length - 1].push({ id: this.$t('bandeauConfiguration.' + key), value: value, type: 'text', label: this.$t('bandeauConfiguration.' + key) })
          currentIndex++
        }
        this.dataLoaded = true
      })
  },

  methods: {
    getWidth (row) {
      if (row.length === 1) {
        return 'large'
      }
      return 'small'
    }
  }
}
</script>

<style lang="scss">
html {
    position: relative;
    min-height: 100%;
}
  .back-layout {
    padding-bottom: 80px;
    @import '../../../../assets/sass/backoffice/main';
  }
</style>
